import { Movement } from '../store/types';

export interface MovementHistoryResponse {
  elements: Movement[];
  pagination: {
    totalElements: number;
    hasNextPage: boolean;
    nextPage: number;
    previousPage: number;
    lastPage: number;
    currentPage: number;
    limit: number;
  };
}

/** Tipo de estadística: ingresos (entradas) o gastos (salidas). */
export type StatisticsType = 'income' | 'expense';

export interface IncomeStatisticsPoint {
  /** Fecha del día en formato YYYY-MM-DD (hora de Cuba). */
  date: string;
  amount: number;
  count: number;
}

export interface MovementsStatisticsResponse {
  totalIncome: number;
  transactionCount: number;
  averageDailyIncome: number;
  bestDay: { date: string; amount: number } | null;
  timeline: IncomeStatisticsPoint[];
}

export enum FilterOperator {
  EQ = 'eq',
  GTE = 'gte',
  LTE = 'lte',
  GT = 'gt',
  LT = 'lt'
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export interface PaginationDtoNoFilter {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: SortOrder;
}

export interface MovementHistoryFilters {
  transactionTypeId?: string;
  // Date range filters (new approach)
  startDate?: string;
  endDate?: string;
  // Legacy single date filter (deprecated, for backward compatibility)
  date?: string;
  dateOperator?: FilterOperator;
  amount?: string;
  amountOperator?: FilterOperator;
  search?: string;
  pagination?: PaginationDtoNoFilter;
  metadataFilters?: Record<string, MetadataFilterValue>;
}

export interface MetadataFilterValue {
  value: string;
  operator?: FilterOperator;
}

export interface MetadataFieldOption {
  key: string;
  altKeys: string[];
  label: string;
  fieldType: 'string' | 'number';
  values: string[];
}
